import {UserService} from './user.service';

export const UserInjectables: Array<any> = [
  {provide: UserService, useClass: UserService},
];
